import { render } from "./lrbYTable2.vue?vue&type=template&id=5f01b578&scoped=true"
import script from "./lrbYTable2.vue?vue&type=script&lang=js"
export * from "./lrbYTable2.vue?vue&type=script&lang=js"

import "./lrbYTable2.vue?vue&type=style&index=0&id=5f01b578&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f01b578"]])

export default __exports__